
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91pcpIndex_93SVWdyTdoUQmQwVXmnXRb1Ge3rnOXDjRXR3N2vm9RwqMMeta } from "/var/www/pages/my-account/order-history/[orderNo]/pcp/[pcpIndex].vue?macro=true";
import { default as indexnZ2v9L5M2vS_K416TfwV1QxEh_xYkoymvwPyjZYKRO0Meta } from "/var/www/pages/my-account/order-history/[orderNo]/index.vue?macro=true";
import { default as billinglCo9Eo_uAOqTdXb3zX8RxZtPdKmmNcogD5Gto8kBsI8Meta } from "/var/www/pages/checkout/billing.vue?macro=true";
import { default as payment_45processing8NTStO1czQDHdoxX201durYfiOrFeqpUbwb6V5SwX5EMeta } from "/var/www/pages/checkout/payment-processing.vue?macro=true";
import { default as shippingovKvBM07Bx4tFYboEP26FEp0QGYKnK2l28zP4GbM05EMeta } from "/var/www/pages/checkout/shipping.vue?macro=true";
import { default as thank_45younpeAe_l5inNPzaSC4Y9n9SAhQvzwq8lo5KZRfuJL8o0Meta } from "/var/www/pages/checkout/thank-you.vue?macro=true";
import { default as brazeT689PkwSMMyPWCJGkbQakgiqpB9m9RJULKEdkAxRdswMeta } from "/var/www/pages/debug/braze.vue?macro=true";
import { default as iconsCvpro97Ww01B_UgmCEeW1gVAdsCYdlZ6BfVUPLwJ2fQMeta } from "/var/www/pages/debug/icons.vue?macro=true";
import { default as flexiti_45applyCNHjZ1EY06yd6EIiPb4IaMycr0s9GNKU7dP3dNHT8XoMeta } from "/var/www/pages/finance-options/flexiti-apply.vue?macro=true";
import { default as account_45activationjSJhEo3edzTtn9kZKYZTmd55PJKFLjONUQxgwNEOazgMeta } from "/var/www/pages/my-account/account-activation.vue?macro=true";
import { default as contact_45detailsFxsHspUnsc8npbsHTwpQa8PQNfFsNxQAwXrGk_b9susMeta } from "/var/www/pages/my-account/contact-details.vue?macro=true";
import { default as my_45offersuDH1Lpr_J3gsCzY_OvxLgu242K0nqcDU5LpVH5BAzokMeta } from "/var/www/pages/my-account/my-offers.vue?macro=true";
import { default as indexsiuYIf6fqG8DRkRgY5_SYLk4y9ub8sMmRy0PRdUX22gMeta } from "/var/www/pages/my-account/order-history/index.vue?macro=true";
import { default as register4EkpEWvC4CaskBD9XQ4J11KU2TO6ezHCVKSt6_rWiu8Meta } from "/var/www/pages/my-account/register.vue?macro=true";
import { default as wishlistZfl0bCD5l_ej2_3KrVglmXJNby_zNOMDzCFRd_t4vWkMeta } from "/var/www/pages/my-account/wishlist.vue?macro=true";
import { default as _91slug_93u5GjJecre46VKr3Fut__w2R07ziUDjdYmURNscCqz90Meta } from "/var/www/pages/connected/[slug].vue?macro=true";
import { default as _91product_93dWvza1oIRdarjIUYPhrSM4IF1_Gw5QGIKpjJUAU2jlUMeta } from "/var/www/pages/p/[product].vue?macro=true";
import { default as _91contentTypePage_93iMgXTt_M_YbhY9QvXyaFFp_PQ_82D5bRYK2WLO1uxJcMeta } from "/var/www/pages/preview/[contentTypePage].vue?macro=true";
import { default as _91store_93tB_2U1rSZfnejASlRJSZ3QUrHoAUeQpYxCYp6Md7LhEMeta } from "/var/www/pages/stores/[store].vue?macro=true";
import { default as auth_45redirect0pzBzl0yQtvgOmrlHVyQTSzadY7GkkLrzZgxRkf2fGIMeta } from "/var/www/pages/auth-redirect.vue?macro=true";
import { default as healthzLzG7CYQJMUKvlZiZ6efHdvY8E5bxb3JXlOCxEboGoJYMeta } from "/var/www/pages/healthz.vue?macro=true";
import { default as jewellery_45builderbuiFPspqjmz5NSAlaUu98pJTvMkzrW5nn6R9uktuU5IMeta } from "/var/www/pages/jewellery-builder.vue?macro=true";
import { default as index13OLarVyZfMvosresFm3wWYRW_2wr0qRBLltkP5g_b4Meta } from "/var/www/pages/my-account/index.vue?macro=true";
import { default as my_45bagwVhN_jclChkAUc68s3iEkdvHSbYD6ZIqp_83DW_6rtsMeta } from "/var/www/pages/my-bag.vue?macro=true";
import { default as searchLYzC3v_xfFdxfvOJQx03yrDB2P75HHSNNx38jaiavwIMeta } from "/var/www/pages/search.vue?macro=true";
import { default as indexAcdy_SJtC3HhhRRcQZXuuh3HdGvfzQIzgzBZDTsHZjcMeta } from "/var/www/pages/stores/index.vue?macro=true";
import { default as wishlistQ_DbUUpRRiQqKWDb04fQCMZhaGcm_TJcMS6_w7sjJuQMeta } from "/var/www/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93Z_A_Z3YYyKi0ogRxbcKH3edT09D9cqWC43RG2cxzWv4Meta } from "/var/www/pages/[...slug].vue?macro=true";
export default [
  {
    name: "my-account-order-history-orderNo-pcp-pcpIndex___en-AU",
    path: "/my-account/order-history/:orderNo()/pcp/:pcpIndex()",
    meta: _91pcpIndex_93SVWdyTdoUQmQwVXmnXRb1Ge3rnOXDjRXR3N2vm9RwqMMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/pcp/[pcpIndex].vue")
  },
  {
    name: "my-account-order-history-orderNo-pcp-pcpIndex___en-CA",
    path: "/my-account/order-history/:orderNo()/pcp/:pcpIndex()",
    meta: _91pcpIndex_93SVWdyTdoUQmQwVXmnXRb1Ge3rnOXDjRXR3N2vm9RwqMMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/pcp/[pcpIndex].vue")
  },
  {
    name: "my-account-order-history-orderNo-pcp-pcpIndex___fr",
    path: "/fr/my-account/order-history/:orderNo()/pcp/:pcpIndex()",
    meta: _91pcpIndex_93SVWdyTdoUQmQwVXmnXRb1Ge3rnOXDjRXR3N2vm9RwqMMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/pcp/[pcpIndex].vue")
  },
  {
    name: "my-account-order-history-orderNo-pcp-pcpIndex___en-NZ",
    path: "/my-account/order-history/:orderNo()/pcp/:pcpIndex()",
    meta: _91pcpIndex_93SVWdyTdoUQmQwVXmnXRb1Ge3rnOXDjRXR3N2vm9RwqMMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/pcp/[pcpIndex].vue")
  },
  {
    name: "my-account-order-history-orderNo___en-AU",
    path: "/my-account/order-history/:orderNo()",
    meta: indexnZ2v9L5M2vS_K416TfwV1QxEh_xYkoymvwPyjZYKRO0Meta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/index.vue")
  },
  {
    name: "my-account-order-history-orderNo___en-CA",
    path: "/my-account/order-history/:orderNo()",
    meta: indexnZ2v9L5M2vS_K416TfwV1QxEh_xYkoymvwPyjZYKRO0Meta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/index.vue")
  },
  {
    name: "my-account-order-history-orderNo___fr",
    path: "/fr/my-account/order-history/:orderNo()",
    meta: indexnZ2v9L5M2vS_K416TfwV1QxEh_xYkoymvwPyjZYKRO0Meta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/index.vue")
  },
  {
    name: "my-account-order-history-orderNo___en-NZ",
    path: "/my-account/order-history/:orderNo()",
    meta: indexnZ2v9L5M2vS_K416TfwV1QxEh_xYkoymvwPyjZYKRO0Meta || {},
    component: () => import("/var/www/pages/my-account/order-history/[orderNo]/index.vue")
  },
  {
    name: "checkout-billing___en-AU",
    path: "/checkout/billing",
    meta: billinglCo9Eo_uAOqTdXb3zX8RxZtPdKmmNcogD5Gto8kBsI8Meta || {},
    component: () => import("/var/www/pages/checkout/billing.vue")
  },
  {
    name: "checkout-billing___en-CA",
    path: "/checkout/billing",
    meta: billinglCo9Eo_uAOqTdXb3zX8RxZtPdKmmNcogD5Gto8kBsI8Meta || {},
    component: () => import("/var/www/pages/checkout/billing.vue")
  },
  {
    name: "checkout-billing___fr",
    path: "/fr/checkout/billing",
    meta: billinglCo9Eo_uAOqTdXb3zX8RxZtPdKmmNcogD5Gto8kBsI8Meta || {},
    component: () => import("/var/www/pages/checkout/billing.vue")
  },
  {
    name: "checkout-billing___en-NZ",
    path: "/checkout/billing",
    meta: billinglCo9Eo_uAOqTdXb3zX8RxZtPdKmmNcogD5Gto8kBsI8Meta || {},
    component: () => import("/var/www/pages/checkout/billing.vue")
  },
  {
    name: "checkout-payment-processing___en-AU",
    path: "/checkout/payment-processing",
    meta: payment_45processing8NTStO1czQDHdoxX201durYfiOrFeqpUbwb6V5SwX5EMeta || {},
    component: () => import("/var/www/pages/checkout/payment-processing.vue")
  },
  {
    name: "checkout-payment-processing___en-CA",
    path: "/checkout/payment-processing",
    meta: payment_45processing8NTStO1czQDHdoxX201durYfiOrFeqpUbwb6V5SwX5EMeta || {},
    component: () => import("/var/www/pages/checkout/payment-processing.vue")
  },
  {
    name: "checkout-payment-processing___fr",
    path: "/fr/checkout/payment-processing",
    meta: payment_45processing8NTStO1czQDHdoxX201durYfiOrFeqpUbwb6V5SwX5EMeta || {},
    component: () => import("/var/www/pages/checkout/payment-processing.vue")
  },
  {
    name: "checkout-payment-processing___en-NZ",
    path: "/checkout/payment-processing",
    meta: payment_45processing8NTStO1czQDHdoxX201durYfiOrFeqpUbwb6V5SwX5EMeta || {},
    component: () => import("/var/www/pages/checkout/payment-processing.vue")
  },
  {
    name: "checkout-shipping___en-AU",
    path: "/checkout/shipping",
    meta: shippingovKvBM07Bx4tFYboEP26FEp0QGYKnK2l28zP4GbM05EMeta || {},
    component: () => import("/var/www/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___en-CA",
    path: "/checkout/shipping",
    meta: shippingovKvBM07Bx4tFYboEP26FEp0QGYKnK2l28zP4GbM05EMeta || {},
    component: () => import("/var/www/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___fr",
    path: "/fr/checkout/shipping",
    meta: shippingovKvBM07Bx4tFYboEP26FEp0QGYKnK2l28zP4GbM05EMeta || {},
    component: () => import("/var/www/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___en-NZ",
    path: "/checkout/shipping",
    meta: shippingovKvBM07Bx4tFYboEP26FEp0QGYKnK2l28zP4GbM05EMeta || {},
    component: () => import("/var/www/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-thank-you___en-AU",
    path: "/checkout/thank-you",
    meta: thank_45younpeAe_l5inNPzaSC4Y9n9SAhQvzwq8lo5KZRfuJL8o0Meta || {},
    component: () => import("/var/www/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___en-CA",
    path: "/checkout/thank-you",
    meta: thank_45younpeAe_l5inNPzaSC4Y9n9SAhQvzwq8lo5KZRfuJL8o0Meta || {},
    component: () => import("/var/www/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___fr",
    path: "/fr/checkout/thank-you",
    meta: thank_45younpeAe_l5inNPzaSC4Y9n9SAhQvzwq8lo5KZRfuJL8o0Meta || {},
    component: () => import("/var/www/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___en-NZ",
    path: "/checkout/thank-you",
    meta: thank_45younpeAe_l5inNPzaSC4Y9n9SAhQvzwq8lo5KZRfuJL8o0Meta || {},
    component: () => import("/var/www/pages/checkout/thank-you.vue")
  },
  {
    name: "debug-braze___en-AU",
    path: "/debug/braze",
    meta: brazeT689PkwSMMyPWCJGkbQakgiqpB9m9RJULKEdkAxRdswMeta || {},
    component: () => import("/var/www/pages/debug/braze.vue")
  },
  {
    name: "debug-braze___en-CA",
    path: "/debug/braze",
    meta: brazeT689PkwSMMyPWCJGkbQakgiqpB9m9RJULKEdkAxRdswMeta || {},
    component: () => import("/var/www/pages/debug/braze.vue")
  },
  {
    name: "debug-braze___fr",
    path: "/fr/debug/braze",
    meta: brazeT689PkwSMMyPWCJGkbQakgiqpB9m9RJULKEdkAxRdswMeta || {},
    component: () => import("/var/www/pages/debug/braze.vue")
  },
  {
    name: "debug-braze___en-NZ",
    path: "/debug/braze",
    meta: brazeT689PkwSMMyPWCJGkbQakgiqpB9m9RJULKEdkAxRdswMeta || {},
    component: () => import("/var/www/pages/debug/braze.vue")
  },
  {
    name: "debug-icons___en-AU",
    path: "/debug/icons",
    meta: iconsCvpro97Ww01B_UgmCEeW1gVAdsCYdlZ6BfVUPLwJ2fQMeta || {},
    component: () => import("/var/www/pages/debug/icons.vue")
  },
  {
    name: "debug-icons___en-CA",
    path: "/debug/icons",
    meta: iconsCvpro97Ww01B_UgmCEeW1gVAdsCYdlZ6BfVUPLwJ2fQMeta || {},
    component: () => import("/var/www/pages/debug/icons.vue")
  },
  {
    name: "debug-icons___fr",
    path: "/fr/debug/icons",
    meta: iconsCvpro97Ww01B_UgmCEeW1gVAdsCYdlZ6BfVUPLwJ2fQMeta || {},
    component: () => import("/var/www/pages/debug/icons.vue")
  },
  {
    name: "debug-icons___en-NZ",
    path: "/debug/icons",
    meta: iconsCvpro97Ww01B_UgmCEeW1gVAdsCYdlZ6BfVUPLwJ2fQMeta || {},
    component: () => import("/var/www/pages/debug/icons.vue")
  },
  {
    name: "finance-options-flexiti-apply___en-AU",
    path: "/finance-options/flexiti-apply",
    component: () => import("/var/www/pages/finance-options/flexiti-apply.vue")
  },
  {
    name: "finance-options-flexiti-apply___en-CA",
    path: "/finance-options/flexiti-apply",
    component: () => import("/var/www/pages/finance-options/flexiti-apply.vue")
  },
  {
    name: "finance-options-flexiti-apply___fr",
    path: "/fr/finance-options/flexiti-apply",
    component: () => import("/var/www/pages/finance-options/flexiti-apply.vue")
  },
  {
    name: "finance-options-flexiti-apply___en-NZ",
    path: "/finance-options/flexiti-apply",
    component: () => import("/var/www/pages/finance-options/flexiti-apply.vue")
  },
  {
    name: "my-account-account-activation___en-AU",
    path: "/my-account/account-activation",
    meta: account_45activationjSJhEo3edzTtn9kZKYZTmd55PJKFLjONUQxgwNEOazgMeta || {},
    component: () => import("/var/www/pages/my-account/account-activation.vue")
  },
  {
    name: "my-account-account-activation___en-CA",
    path: "/my-account/account-activation",
    meta: account_45activationjSJhEo3edzTtn9kZKYZTmd55PJKFLjONUQxgwNEOazgMeta || {},
    component: () => import("/var/www/pages/my-account/account-activation.vue")
  },
  {
    name: "my-account-account-activation___fr",
    path: "/fr/my-account/account-activation",
    meta: account_45activationjSJhEo3edzTtn9kZKYZTmd55PJKFLjONUQxgwNEOazgMeta || {},
    component: () => import("/var/www/pages/my-account/account-activation.vue")
  },
  {
    name: "my-account-account-activation___en-NZ",
    path: "/my-account/account-activation",
    meta: account_45activationjSJhEo3edzTtn9kZKYZTmd55PJKFLjONUQxgwNEOazgMeta || {},
    component: () => import("/var/www/pages/my-account/account-activation.vue")
  },
  {
    name: "my-account-contact-details___en-AU",
    path: "/my-account/contact-details",
    meta: contact_45detailsFxsHspUnsc8npbsHTwpQa8PQNfFsNxQAwXrGk_b9susMeta || {},
    component: () => import("/var/www/pages/my-account/contact-details.vue")
  },
  {
    name: "my-account-contact-details___en-CA",
    path: "/my-account/contact-details",
    meta: contact_45detailsFxsHspUnsc8npbsHTwpQa8PQNfFsNxQAwXrGk_b9susMeta || {},
    component: () => import("/var/www/pages/my-account/contact-details.vue")
  },
  {
    name: "my-account-contact-details___fr",
    path: "/fr/my-account/contact-details",
    meta: contact_45detailsFxsHspUnsc8npbsHTwpQa8PQNfFsNxQAwXrGk_b9susMeta || {},
    component: () => import("/var/www/pages/my-account/contact-details.vue")
  },
  {
    name: "my-account-contact-details___en-NZ",
    path: "/my-account/contact-details",
    meta: contact_45detailsFxsHspUnsc8npbsHTwpQa8PQNfFsNxQAwXrGk_b9susMeta || {},
    component: () => import("/var/www/pages/my-account/contact-details.vue")
  },
  {
    name: "my-account-my-offers___en-AU",
    path: "/my-account/my-offers",
    meta: my_45offersuDH1Lpr_J3gsCzY_OvxLgu242K0nqcDU5LpVH5BAzokMeta || {},
    component: () => import("/var/www/pages/my-account/my-offers.vue")
  },
  {
    name: "my-account-my-offers___en-CA",
    path: "/my-account/my-offers",
    meta: my_45offersuDH1Lpr_J3gsCzY_OvxLgu242K0nqcDU5LpVH5BAzokMeta || {},
    component: () => import("/var/www/pages/my-account/my-offers.vue")
  },
  {
    name: "my-account-my-offers___fr",
    path: "/fr/my-account/my-offers",
    meta: my_45offersuDH1Lpr_J3gsCzY_OvxLgu242K0nqcDU5LpVH5BAzokMeta || {},
    component: () => import("/var/www/pages/my-account/my-offers.vue")
  },
  {
    name: "my-account-my-offers___en-NZ",
    path: "/my-account/my-offers",
    meta: my_45offersuDH1Lpr_J3gsCzY_OvxLgu242K0nqcDU5LpVH5BAzokMeta || {},
    component: () => import("/var/www/pages/my-account/my-offers.vue")
  },
  {
    name: "my-account-order-history___en-AU",
    path: "/my-account/order-history",
    meta: indexsiuYIf6fqG8DRkRgY5_SYLk4y9ub8sMmRy0PRdUX22gMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/index.vue")
  },
  {
    name: "my-account-order-history___en-CA",
    path: "/my-account/order-history",
    meta: indexsiuYIf6fqG8DRkRgY5_SYLk4y9ub8sMmRy0PRdUX22gMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/index.vue")
  },
  {
    name: "my-account-order-history___fr",
    path: "/fr/my-account/order-history",
    meta: indexsiuYIf6fqG8DRkRgY5_SYLk4y9ub8sMmRy0PRdUX22gMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/index.vue")
  },
  {
    name: "my-account-order-history___en-NZ",
    path: "/my-account/order-history",
    meta: indexsiuYIf6fqG8DRkRgY5_SYLk4y9ub8sMmRy0PRdUX22gMeta || {},
    component: () => import("/var/www/pages/my-account/order-history/index.vue")
  },
  {
    name: "my-account-register___en-AU",
    path: "/my-account/register",
    meta: register4EkpEWvC4CaskBD9XQ4J11KU2TO6ezHCVKSt6_rWiu8Meta || {},
    component: () => import("/var/www/pages/my-account/register.vue")
  },
  {
    name: "my-account-register___en-CA",
    path: "/my-account/register",
    meta: register4EkpEWvC4CaskBD9XQ4J11KU2TO6ezHCVKSt6_rWiu8Meta || {},
    component: () => import("/var/www/pages/my-account/register.vue")
  },
  {
    name: "my-account-register___fr",
    path: "/fr/my-account/register",
    meta: register4EkpEWvC4CaskBD9XQ4J11KU2TO6ezHCVKSt6_rWiu8Meta || {},
    component: () => import("/var/www/pages/my-account/register.vue")
  },
  {
    name: "my-account-register___en-NZ",
    path: "/my-account/register",
    meta: register4EkpEWvC4CaskBD9XQ4J11KU2TO6ezHCVKSt6_rWiu8Meta || {},
    component: () => import("/var/www/pages/my-account/register.vue")
  },
  {
    name: "my-account-wishlist___en-AU",
    path: "/my-account/wishlist",
    meta: wishlistZfl0bCD5l_ej2_3KrVglmXJNby_zNOMDzCFRd_t4vWkMeta || {},
    component: () => import("/var/www/pages/my-account/wishlist.vue")
  },
  {
    name: "my-account-wishlist___en-CA",
    path: "/my-account/wishlist",
    meta: wishlistZfl0bCD5l_ej2_3KrVglmXJNby_zNOMDzCFRd_t4vWkMeta || {},
    component: () => import("/var/www/pages/my-account/wishlist.vue")
  },
  {
    name: "my-account-wishlist___fr",
    path: "/fr/my-account/wishlist",
    meta: wishlistZfl0bCD5l_ej2_3KrVglmXJNby_zNOMDzCFRd_t4vWkMeta || {},
    component: () => import("/var/www/pages/my-account/wishlist.vue")
  },
  {
    name: "my-account-wishlist___en-NZ",
    path: "/my-account/wishlist",
    meta: wishlistZfl0bCD5l_ej2_3KrVglmXJNby_zNOMDzCFRd_t4vWkMeta || {},
    component: () => import("/var/www/pages/my-account/wishlist.vue")
  },
  {
    name: "connected-slug___en-AU",
    path: "/connected/:slug()",
    component: () => import("/var/www/pages/connected/[slug].vue")
  },
  {
    name: "connected-slug___en-CA",
    path: "/connected/:slug()",
    component: () => import("/var/www/pages/connected/[slug].vue")
  },
  {
    name: "connected-slug___fr",
    path: "/fr/connected/:slug()",
    component: () => import("/var/www/pages/connected/[slug].vue")
  },
  {
    name: "connected-slug___en-NZ",
    path: "/connected/:slug()",
    component: () => import("/var/www/pages/connected/[slug].vue")
  },
  {
    name: "p-product___en-AU",
    path: "/p/:product()",
    component: () => import("/var/www/pages/p/[product].vue")
  },
  {
    name: "p-product___en-CA",
    path: "/p/:product()",
    component: () => import("/var/www/pages/p/[product].vue")
  },
  {
    name: "p-product___fr",
    path: "/fr/p/:product()",
    component: () => import("/var/www/pages/p/[product].vue")
  },
  {
    name: "p-product___en-NZ",
    path: "/p/:product()",
    component: () => import("/var/www/pages/p/[product].vue")
  },
  {
    name: "preview-contentTypePage___en-AU",
    path: "/preview/:contentTypePage()",
    component: () => import("/var/www/pages/preview/[contentTypePage].vue")
  },
  {
    name: "preview-contentTypePage___en-CA",
    path: "/preview/:contentTypePage()",
    component: () => import("/var/www/pages/preview/[contentTypePage].vue")
  },
  {
    name: "preview-contentTypePage___fr",
    path: "/fr/preview/:contentTypePage()",
    component: () => import("/var/www/pages/preview/[contentTypePage].vue")
  },
  {
    name: "preview-contentTypePage___en-NZ",
    path: "/preview/:contentTypePage()",
    component: () => import("/var/www/pages/preview/[contentTypePage].vue")
  },
  {
    name: "stores-store___en-AU",
    path: "/stores/:store()",
    component: () => import("/var/www/pages/stores/[store].vue")
  },
  {
    name: "stores-store___en-CA",
    path: "/stores/:store()",
    component: () => import("/var/www/pages/stores/[store].vue")
  },
  {
    name: "stores-store___fr",
    path: "/fr/stores/:store()",
    component: () => import("/var/www/pages/stores/[store].vue")
  },
  {
    name: "stores-store___en-NZ",
    path: "/stores/:store()",
    component: () => import("/var/www/pages/stores/[store].vue")
  },
  {
    name: "auth-redirect___en-AU",
    path: "/auth-redirect",
    meta: auth_45redirect0pzBzl0yQtvgOmrlHVyQTSzadY7GkkLrzZgxRkf2fGIMeta || {},
    component: () => import("/var/www/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___en-CA",
    path: "/auth-redirect",
    meta: auth_45redirect0pzBzl0yQtvgOmrlHVyQTSzadY7GkkLrzZgxRkf2fGIMeta || {},
    component: () => import("/var/www/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___fr",
    path: "/fr/auth-redirect",
    meta: auth_45redirect0pzBzl0yQtvgOmrlHVyQTSzadY7GkkLrzZgxRkf2fGIMeta || {},
    component: () => import("/var/www/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___en-NZ",
    path: "/auth-redirect",
    meta: auth_45redirect0pzBzl0yQtvgOmrlHVyQTSzadY7GkkLrzZgxRkf2fGIMeta || {},
    component: () => import("/var/www/pages/auth-redirect.vue")
  },
  {
    name: "healthz___en-AU",
    path: "/healthz",
    meta: healthzLzG7CYQJMUKvlZiZ6efHdvY8E5bxb3JXlOCxEboGoJYMeta || {},
    component: () => import("/var/www/pages/healthz.vue")
  },
  {
    name: "healthz___en-CA",
    path: "/healthz",
    meta: healthzLzG7CYQJMUKvlZiZ6efHdvY8E5bxb3JXlOCxEboGoJYMeta || {},
    component: () => import("/var/www/pages/healthz.vue")
  },
  {
    name: "healthz___fr",
    path: "/fr/healthz",
    meta: healthzLzG7CYQJMUKvlZiZ6efHdvY8E5bxb3JXlOCxEboGoJYMeta || {},
    component: () => import("/var/www/pages/healthz.vue")
  },
  {
    name: "healthz___en-NZ",
    path: "/healthz",
    meta: healthzLzG7CYQJMUKvlZiZ6efHdvY8E5bxb3JXlOCxEboGoJYMeta || {},
    component: () => import("/var/www/pages/healthz.vue")
  },
  {
    name: "jewellery-builder___en-AU",
    path: "/jewellery-builder",
    component: () => import("/var/www/pages/jewellery-builder.vue")
  },
  {
    name: "jewellery-builder___en-CA",
    path: "/jewellery-builder",
    component: () => import("/var/www/pages/jewellery-builder.vue")
  },
  {
    name: "jewellery-builder___fr",
    path: "/fr/jewellery-builder",
    component: () => import("/var/www/pages/jewellery-builder.vue")
  },
  {
    name: "jewellery-builder___en-NZ",
    path: "/jewellery-builder",
    component: () => import("/var/www/pages/jewellery-builder.vue")
  },
  {
    name: "my-account___en-AU",
    path: "/my-account",
    meta: index13OLarVyZfMvosresFm3wWYRW_2wr0qRBLltkP5g_b4Meta || {},
    component: () => import("/var/www/pages/my-account/index.vue")
  },
  {
    name: "my-account___en-CA",
    path: "/my-account",
    meta: index13OLarVyZfMvosresFm3wWYRW_2wr0qRBLltkP5g_b4Meta || {},
    component: () => import("/var/www/pages/my-account/index.vue")
  },
  {
    name: "my-account___fr",
    path: "/fr/my-account",
    meta: index13OLarVyZfMvosresFm3wWYRW_2wr0qRBLltkP5g_b4Meta || {},
    component: () => import("/var/www/pages/my-account/index.vue")
  },
  {
    name: "my-account___en-NZ",
    path: "/my-account",
    meta: index13OLarVyZfMvosresFm3wWYRW_2wr0qRBLltkP5g_b4Meta || {},
    component: () => import("/var/www/pages/my-account/index.vue")
  },
  {
    name: "my-bag___en-AU",
    path: "/my-bag",
    component: () => import("/var/www/pages/my-bag.vue")
  },
  {
    name: "my-bag___en-CA",
    path: "/my-bag",
    component: () => import("/var/www/pages/my-bag.vue")
  },
  {
    name: "my-bag___fr",
    path: "/fr/my-bag",
    component: () => import("/var/www/pages/my-bag.vue")
  },
  {
    name: "my-bag___en-NZ",
    path: "/my-bag",
    component: () => import("/var/www/pages/my-bag.vue")
  },
  {
    name: "search___en-AU",
    path: "/search",
    component: () => import("/var/www/pages/search.vue")
  },
  {
    name: "search___en-CA",
    path: "/search",
    component: () => import("/var/www/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/var/www/pages/search.vue")
  },
  {
    name: "search___en-NZ",
    path: "/search",
    component: () => import("/var/www/pages/search.vue")
  },
  {
    name: "stores___en-AU",
    path: "/stores",
    component: () => import("/var/www/pages/stores/index.vue")
  },
  {
    name: "stores___en-CA",
    path: "/stores",
    component: () => import("/var/www/pages/stores/index.vue")
  },
  {
    name: "stores___fr",
    path: "/fr/stores",
    component: () => import("/var/www/pages/stores/index.vue")
  },
  {
    name: "stores___en-NZ",
    path: "/stores",
    component: () => import("/var/www/pages/stores/index.vue")
  },
  {
    name: "wishlist___en-AU",
    path: "/wishlist",
    component: () => import("/var/www/pages/wishlist.vue")
  },
  {
    name: "wishlist___en-CA",
    path: "/wishlist",
    component: () => import("/var/www/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    component: () => import("/var/www/pages/wishlist.vue")
  },
  {
    name: "wishlist___en-NZ",
    path: "/wishlist",
    component: () => import("/var/www/pages/wishlist.vue")
  },
  {
    name: "slug___en-AU",
    path: "/:slug(.*)*",
    component: () => import("/var/www/pages/[...slug].vue")
  },
  {
    name: "slug___en-CA",
    path: "/:slug(.*)*",
    component: () => import("/var/www/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/var/www/pages/[...slug].vue")
  },
  {
    name: "slug___en-NZ",
    path: "/:slug(.*)*",
    component: () => import("/var/www/pages/[...slug].vue")
  }
]